import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';

import { UserContext } from '../auth/hook/userContext';
import { getPartners, visitCommunityPage } from '../../store/partners/partners.service';
import useAsyncLoad from '../../hooks/useAsyncLoad';

import Box from '../atoms/Box';
import Discord from './Discord';
import PartnerForLoggedUser from './PartnerForLoggedUser';

import { handle, toastMainError } from '../../infrastructure/validation/error';
import { toast } from 'react-toastify';
import { useTranslate } from '../../translate/I18n';

const StyledPartnerBox = styled(Box)(({ theme }) => ({
  [`@media (min-width: ${theme.breakpoints.lg})`]: {
    maxWidth: '50%',
    '&:nth-child(odd)': {
      paddingRight: '10px'
    },
    '&:nth-child(even)': {
      paddingLeft: '10px'
    }
  }
}));

export const Community = () => {
  const user = useContext(UserContext);
  const { t } = useTranslate();

  const { isLoading, result: partners } = useAsyncLoad(async () => {
    try {
      return await getPartners();
    } catch (error) {
      handle(error).with(toastMainError(toast.error, t));
    }
  });

  useEffect(() => {
    try {
      visitCommunityPage();
    } catch (error) { }
  }, []);

  if (isLoading) return null;

  return (
    <Box maxWidth="1280px" mx="auto" pt={4} px={2}>
      {user.isFreelance() && (
        <Box mb={4}>
          <Discord />
        </Box>
      )}
      <Box display="flex" flexDirection={{ _: 'column', lg: 'row' }} flexWrap="wrap">
        {partners &&
          partners.map(({ id, categories, updateDate, noFollow }) => (
            <StyledPartnerBox key={id} mb={2}>
              <PartnerForLoggedUser
                id={id}
                categories={categories}
                noFollow={noFollow}
                hasNotification={user.hasNewPartner(updateDate)}
              />
            </StyledPartnerBox>
          ))}
      </Box>
    </Box>
  );
};

export default Community;
